import React, { useEffect } from "react";
import { useState } from "react";
import {
  Button,
  Card,
  Divider,
  FormControl,
  Grid,
  InputAdornment,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import { getFarmer } from "../../../redux/reducer/farmer/farmerReducer";
import NumberFormatting from "../../helper/NumberFormatting";
import {
  debtMoneyActions,
  getDebtMoneyById,
  updateDebtMoney,
} from "../../../redux/reducer/debtMoney/debtMoneyReducer";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

const useStyles = makeStyles(() => ({
  headerClass: {
    display: "flex",
    alignItems: "flex-start",
    width: "100%",
    flexDirection: "column",
    padding: "5px",
    margin: "10px 0px",
    background: "#F2F2F2",
  },
  dividerStyle: {
    border: "1px solid #386E5B",
    width: "100%",
    margin: "5px 0px",
  },
  footerButton: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    marginBottom: "10px",
    width: "99%",
  },
  tableHeader: {
    background: "#ddd",
    textAlign: "center",
    borderBottom: "1px solid #D1CDCD",
    padding: "1em",
  },
  tableCell: {
    background: "#ddd",
    borderBottom: "1px solid #D1CDCD",
    padding: "5px 0px",
  },
  actionButtonEdit: {
    backgroundColor: "#dde0f0",
    color: "#A0A3B3",
    fontSize: "25px",
    textAlign: "center",
    borderRadius: "5px",
    margin: "auto",
    cursor: "pointer",
    "&:hover": {
      background: "#7dbda9",
    },
  },
}));

export default function FarmerDebtMoneyEdit() {
  // Navigate
  const navigate = useNavigate();
  const { id } = useParams();

  // Styling
  const styles = useStyles();

  // Redux Data
  const dispatch = useDispatch();
  const data = useSelector((state) => state.debtMoney.data);
  const token = useSelector((state) => state.auth.token);
  const farmer = useSelector((state) => state.farmer.data);

  // Local State
  const [paidDetails, setPaidDetails] = useState([]);
  const [formData, setFormData] = useState({
    farmerId: "",
    submissionDate: "",
    amount: "",
    tenor: "",
  });

  useEffect(() => {
    let x = data.docs.findIndex((item) => item._id === id);
    if (x > -1) {
      setFormData({
        farmerId: data.docs[x].farmerId ? data.docs[x].farmerId._id : "",
        submissionDate: data.docs[x].debtDetails
          ? data.docs[x].debtDetails.submissionDate
          : "",
        amount: data.docs[x].debtDetails ? data.docs[x].debtDetails.amount : "",
        remainingAmount: data.docs[x].debtDetails
          ? data.docs[x].debtDetails.remainingAmount
          : "",
        tenor: data.docs[x].debtDetails ? data.docs[x].debtDetails.tenor : "",
      });
      let newData = [];
      data.docs[x].paidDetails.map((item) => {
        let data = {
          ...item,
        };
        newData.push(data);
      });
      setPaidDetails(newData);
      if (data.docs[x].paidDetails.length === 0) {
        handleAddPaidDetails();
      }
    }
  }, []);

  // Basic Handle Change
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmitAll = (e) => {
    e.preventDefault();
    Swal.fire({
      title: `Mohon dicek kembali data yang akan di input`,
      icon: "warning",
      buttons: true,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Tambah",
      cancelButtonText: "Batal",
    }).then((confirm) => {
      if (confirm.isConfirmed) {
        let data = {
          value: {
            farmerId: formData.farmerId,
            debtDetails: {
              submissionDate: formData.submissionDate,
              amount: formData.amount,
              remainingAmount: formData.remainingAmount,
              tenor: formData.tenor,
            },
            paidDetails: [...paidDetails],
          },
          id: id,
          token: token,
        };
        dispatch(updateDebtMoney(data)).then((res) => {
          if (res.payload.status === 200) {
            let dataGetById = {
              id: res.payload.data._id,
              token: token,
            };
            dispatch(getDebtMoneyById(dataGetById)).then((result) => {
              dispatch(debtMoneyActions.editDebtMoney(result.payload.data));
              toast.success(res.payload.message);
              navigate("/petani/hutang");
            });
          }
        });
      } else {
        return;
      }
    });
  };

  const loadMore = (value) => (event) => {
    if (
      event.target.scrollHeight - event.target.scrollTop < 300 &&
      event.target.scrollTop < 100
    ) {
      if (farmer.totalDocs !== farmer.docs.length && value === 1) {
        const getData = {
          params: {
            limit: farmer.limit + 10,
            page: 1,
          },
          token: token,
        };
        dispatch(getFarmer(getData));
      }
    }
  };

  const paidDetailsColumn = [
    "DIBAYARKAN",
    "TANGGAL BAYAR",
    "KETERANGAN",
    "AKSI",
  ];

  const handleAddPaidDetails = () => {
    setPaidDetails((prevItems) => [
      ...prevItems,
      {
        paidAmount: "",
        paidDate: "",
        description: "",
      },
    ]);
  };

  const handleDeletePaidDetails = (value) => {
    let deletedData = [];
    for (let i = 0; i < paidDetails.length; i++) {
      if (i !== value) {
        deletedData.push(paidDetails[i]);
      }
    }
    setPaidDetails(deletedData);
  };

  const handlePaidDetails = (index) => (e) => {
    const newItems = [...paidDetails];
    newItems[index][e.target.name] = e.target.value;
    setFormData({
      ...formData,
      remainingAmount:
        formData.amount -
        newItems.reduce(
          (acc, cur) => parseInt(acc) + parseInt(cur.paidAmount),
          0
        ),
    });
    setPaidDetails(newItems);
  };

  return (
    <Grid container>
      <ToastContainer />
      <Card className={styles.headerClass}>
        <Typography fontSize={20} fontWeight={600} color={"#0A543B"}>
          TAMBAH HUTANG PETANI
        </Typography>
      </Card>
      <Card className={styles.headerClass}>
        <form
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            marginTop: "10px",
          }}
          onSubmit={handleSubmitAll}
        >
          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              PETANI
            </Typography>
            <TextField
              select
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true }}
              required
              size="small"
              error={false}
              name="farmerId"
              onChange={handleChange}
              value={formData.farmerId}
              fullWidth
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    onScroll: loadMore(1),
                  },
                  style: {
                    height: "300px",
                  },
                },
              }}
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            >
              {farmer.docs.length > 0 ? (
                farmer.docs.map((data, index) => (
                  <MenuItem value={data._id} key={index}>
                    {data.fullName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="">Data kosong</MenuItem>
              )}
            </TextField>
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              TANGGAL HUTANG
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              required
              size="small"
              error={false}
              type="date"
              name="submissionDate"
              onChange={handleChange}
              value={formData.submissionDate}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              marginBottom: "10px",
              width: "100%",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              JUMLAH
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true }}
              required
              size="small"
              InputProps={{
                inputComponent: NumberFormatting,
                startAdornment: <></>,
              }}
              error={false}
              onChange={handleChange}
              value={formData.amount}
              name="amount"
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              marginBottom: "10px",
              width: "100%",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              SISA HUTANG
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true }}
              disabled={true}
              required
              size="small"
              InputProps={{
                inputComponent: NumberFormatting,
                startAdornment: <></>,
              }}
              error={false}
              onChange={handleChange}
              value={formData.remainingAmount}
              name="remainingAmount"
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              marginBottom: "10px",
              width: "100%",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              TENOR
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              required
              size="small"
              error={false}
              onChange={handleChange}
              value={formData.tenor}
              name="tenor"
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <Card className={styles.headerClass}>
            <Grid
              container
              direction={"row"}
              justifyContent={"space-between"}
              alignItems="center"
              minWidth={"100%"}
            >
              <Grid items>
                <Typography fontSize={16} color={"#2D6B56"} variant="h6">
                  DETAIL PEMBAYARAN HUTANG
                </Typography>
              </Grid>
            </Grid>
            <Divider className={styles.dividerStyle} />
            <table
              style={{
                width: "98%",
                margin: "10px",
                borderCollapse: "collapse",
                borderRadius: "1em",
                overflow: "hidden",
              }}
            >
              <thead>
                {paidDetailsColumn.map((item, index) => {
                  return (
                    <td className={styles.tableHeader} key={index}>
                      {item}
                    </td>
                  );
                })}
              </thead>
              <tbody>
                {paidDetails.length > 0 &&
                  paidDetails.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td className={styles.tableCell}>
                          <FormControl
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyItems: "flex-start",
                              flexDirection: "row",
                              margin: "auto",
                              width: "90%",
                            }}
                          >
                            <TextField
                              InputLabelProps={{ shrink: true }}
                              required
                              size="small"
                              InputProps={{
                                inputComponent: NumberFormatting,
                                endAdornment: (
                                  <InputAdornment position="end"></InputAdornment>
                                ),
                              }}
                              error={false}
                              name="paidAmount"
                              id={index}
                              onChange={handlePaidDetails(index)}
                              value={item.paidAmount}
                              variant="outlined"
                              fullWidth
                              style={{
                                background: "white",
                                marginRight: "10px",
                              }}
                            />
                          </FormControl>
                        </td>

                        <td className={styles.tableCell}>
                          <FormControl
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyItems: "flex-start",
                              flexDirection: "row",
                              margin: "auto",
                              width: "90%",
                            }}
                          >
                            <TextField
                              InputLabelProps={{ shrink: true }}
                              required
                              size="small"
                              type="date"
                              error={false}
                              name="paidDate"
                              id={index}
                              onChange={handlePaidDetails(index)}
                              value={item.paidDate}
                              variant="outlined"
                              fullWidth
                              style={{
                                background: "white",
                                marginRight: "10px",
                              }}
                            />
                          </FormControl>
                        </td>

                        <td className={styles.tableCell}>
                          <FormControl
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyItems: "flex-start",
                              flexDirection: "row",
                              margin: "auto",
                              width: "90%",
                            }}
                          >
                            <TextField
                              InputLabelProps={{ shrink: true }}
                              required
                              size="small"
                              error={false}
                              name="description"
                              id={index}
                              onChange={handlePaidDetails(index)}
                              value={item.description}
                              variant="outlined"
                              fullWidth
                              style={{
                                background: "white",
                                marginRight: "10px",
                              }}
                            />
                          </FormControl>
                        </td>

                        <td className={styles.tableCell}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              margin: "auto",
                              width: "100px",
                            }}
                          >
                            <AddIcon
                              className={styles.actionButtonEdit}
                              onClick={() => handleAddPaidDetails()}
                            />
                            {paidDetails.length > 1 && index !== 0 ? (
                              <RemoveIcon
                                className={styles.actionButtonEdit}
                                onClick={() => handleDeletePaidDetails(index)}
                              />
                            ) : (
                              ""
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </Card>

          <div className={styles.footerButton}>
            <Button variant="contained" type="submit">
              SUBMIT
            </Button>
            <Button
              variant="contained"
              color="error"
              style={{ marginLeft: "10px" }}
              onClick={() => navigate("/petani/hutang")}
            >
              KEMBALI
            </Button>
          </div>
        </form>
      </Card>
    </Grid>
  );
}
